import React from "react";

const ChatAgentIcon: React.FC<{ size?: number }> = ({ size = 16 }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="#e91e8c"
    style={{ verticalAlign: "middle" }}
  >
    <path d="M21.26,11.09l-5.96-2.35-2.35-5.96c-.15-.38-.52-.63-.93-.63s-.78.25-.93.63l-2.35,5.96-5.96,2.35c-.38.15-.63.52-.63.93s.25.78.63.93l5.96,2.35,2.35,5.96c.15.38.52.63.93.63s.78-.25.93-.63l2.35-5.96,5.96-2.35c.38-.15.63-.52.63-.93s-.25-.78-.63-.93ZM14.16,13.6c-.26.1-.46.31-.56.56l-1.58,4-1.58-4c-.1-.26-.31-.46-.56-.56l-4-1.58,4-1.58c.26-.1.46-.31.56-.56l1.58-4,1.58,4c.1.26.31.46.56.56l4,1.58-4,1.58Z" />
    <path d="M3,5.66l.51.26c.45.24.82.6,1.06,1.06l.26.51c.17.34.66.34.83,0l.26-.51c.24-.45.6-.82,1.06-1.06l.51-.26c.17-.34-.66,0-.83l-.51-.26c-.45-.24-.82-.6-1.06-1.06l-.26-.51c-.17-.34-.66-.34-.83,0l-.26.51c-.24.45-.6.82-1.06,1.06l-.51.26c-.34.17-.34.66,0,.83Z" />
  </svg>
);

export default ChatAgentIcon;
